<template>

  <div
    class="feed-content"
    :class="{'box-loading': loading}">
    <div
      class="photo"
      v-if="!edit && activity.author_user">
      <Avatar
        :src="imgSrc"
        :name="activity.author_user.name"
        size="40px"
        radius="20px"
        resize="100x100x1" />
    </div>

    <div
      class="content"
      v-if="!edit">
      
      <div
        v-if="permissions.includes('manage_candidates')"
        class="feed-actions dropdown">
        <button
          class="btn btn-sm btn-light"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <i class="fas fa-chevron-down" />
          </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            @click="editNote(activity.note)">
            <i class="fas fa-pencil-alt" /> {{ $t('Edit') }}
            </button>
          <button
            class="dropdown-item"
            @click="deleteNote(activity.note._id)">
            <i class="fas fa-times" /> {{ $t('Remove') }}
            </button>
        </div>
      </div>

      <div><strong>{{ $t('Note') }}</strong></div>

      <div
        class="mt-2"
        v-html="noteToHtml(activity.note.note, activity.note.mention_users)"></div>
      
      <div class="mt-2">
        <small>
          <span
            v-tooltip="$d(new Date(activity.created_at), 'long')">
            {{ $d(new Date(activity.created_at), 'short') }}
            </span>
          <span>
            por {{ activity.author_user.name }} - 
            </span>
          <router-link
            class="link-discreet"
            :to="{path: '/job/' + activity.job._id }">
            {{ activity.job.title }}
            </router-link>
        </small>
      </div>
    </div>

    <div
      class="content"
      v-if="edit">
      <candidate-note-form
        :initValue="edit"
        @updated="updatedNote"
        @cancel="editCancel">
        </candidate-note-form>
    </div>
  </div>

</template>

<script>
import config from '@/config'
import CandidateNoteForm from '../Note/CandidateNoteForm'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'CandidateNoteItem',
  components: {
    CandidateNoteForm,
    Avatar
  },
  props: [
    'activity'
  ],
  data () {
    return {
      loading: false,
      edit: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.activity.author_user.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    editNote (data) {
      this.edit = data
    },
    editCancel () {
      this.edit = false
    },
    updatedNote () {
      this.$store
      .dispatch('getActivities', {
        _id: this.activity._id
      })
      .then(() => {
        this.edit = false
      })
    },
    deleteNote (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteNote', id)
        .then((result) => {
          return this.$store
          .dispatch('deleteActivity', this.activity._id)
        })
        .then((result) => {
          this.loading = false
          this.$emit('deleted', result)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    noteToHtml (note, mentionUsers) {
      if (!mentionUsers) mentionUsers = []
      mentionUsers.forEach(v => {
        note = note.replace(v.key, `<span style="font-weight: bold;">${v.key}</span>`)
      })
      return note.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeedNoteItem.vue